var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupppp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8002 10.1C16.8002 11.3731 16.2945 12.594 15.3943 13.4942C14.4941 14.3943 13.2732 14.9 12.0002 14.9C10.7272 14.9 9.50626 14.3943 8.60608 13.4942C7.70591 12.594 7.2002 11.3731 7.2002 10.1C7.2002 8.82701 7.70591 7.60611 8.60608 6.70594C9.50626 5.80576 10.7272 5.30005 12.0002 5.30005C13.2732 5.30005 14.4941 5.80576 15.3943 6.70594C16.2945 7.60611 16.8002 8.82701 16.8002 10.1Z",
    fill: "#239EC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5104 24.4904C5.1102 24.2336 0 18.9632 0 12.5C0 5.8724 5.3724 0.5 12 0.5C18.6276 0.5 24 5.8724 24 12.5C24 19.1276 18.6276 24.5 12 24.5H11.8356C11.7268 24.5 11.6184 24.4968 11.5104 24.4904ZM4.2996 20.072C4.20988 19.8143 4.17934 19.5398 4.21025 19.2687C4.24116 18.9976 4.33272 18.737 4.47815 18.5062C4.62357 18.2753 4.81912 18.0802 5.05027 17.9353C5.28143 17.7903 5.54226 17.6993 5.8134 17.669C10.491 17.1512 13.5378 17.198 18.1926 17.6798C18.4641 17.7081 18.7256 17.7979 18.9571 17.9425C19.1886 18.0871 19.3841 18.2827 19.5286 18.5142C19.6732 18.7458 19.763 19.0073 19.7912 19.2788C19.8194 19.5503 19.7853 19.8247 19.6914 20.081C21.6865 18.0626 22.8037 15.338 22.8 12.5C22.8 6.5354 17.9646 1.7 12 1.7C6.0354 1.7 1.2 6.5354 1.2 12.5C1.2 15.4496 2.3826 18.1232 4.2996 20.072Z",
    fill: "#239EC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupppp);
export default __webpack_public_path__ + "static/media/Groupppp.d9cf01f202990dfb8d6ead52b1ff11da.svg";
export { ForwardRef as ReactComponent };